import { Clapperboard, Flag, Gem, GlassWater, Sailboat, Trophy } from "lucide-react";
import { Page } from "@/components/Page";
import { PageShell } from "@/components/PageShell";
import { EditorialCard } from "@/components/EditorialCard";
import { SectionIntro } from "@/components/Reveal";
import { useUI } from "@/context/UIContext";
import { IMG } from "@/lib/images";

const EVENTS = [
  {
    image: IMG.f1,
    icon: Flag,
    category: "May · Monte Carlo",
    title: "Monaco Grand Prix",
    description: "Terrace hospitality above the harbour, paddock access and tender transfers.",
    testId: "event-card-monaco",
  },
  {
    image: IMG.gala,
    icon: Gem,
    category: "Year-round · Worldwide",
    title: "Private gala evenings",
    description: "Invitation-only dinners and charity galas in palaces, museums and private clubs.",
    testId: "event-card-galas",
  },
  {
    image: IMG.tennis,
    icon: Trophy,
    category: "July · London",
    title: "Wimbledon hospitality",
    description: "Debenture seats, the Lawn, and Champagne on Centre Court.",
    testId: "event-card-wimbledon",
  },
  {
    image: IMG.cannes,
    icon: Clapperboard,
    category: "May · Côte d'Azur",
    title: "Cannes experiences",
    description: "Festival premieres, villa parties and Croisette evenings beyond the barriers.",
    testId: "event-card-cannes",
  },
  {
    image: IMG.yacht,
    icon: Sailboat,
    category: "Seasonal · Mediterranean",
    title: "Yacht & Riviera charters",
    description: "Crewed charters from Portofino to Palma, provisioned to your table.",
    testId: "event-card-yacht",
  },
  {
    image: IMG.celebration,
    icon: GlassWater,
    category: "By commission",
    title: "Private celebrations",
    description: "Milestone evenings conceived, produced and hosted entirely in confidence.",
    testId: "event-card-celebrations",
  },
];

export default function Events() {
  const { openEnquiry } = useUI();
  return (
    <Page testId="events-page">
      <PageShell
        testId="events-hero"
        eyebrow="Private Events"
        title={
          <>
            Moments the world watches <span className="gold-text italic">from afar.</span>
          </>
        }
        intro="A curated calendar of the season's defining occasions — and the private celebrations we create for our members alone."
        image={IMG.galaTables}
        imageAlt="Candlelit gala dinner tables in a grand hall"
      >
        <section className="mx-auto max-w-[1280px] px-6 py-24 md:py-32 lg:px-12">
          <SectionIntro
            eyebrow="The Calendar"
            title="Curated experiences"
            subtitle="Example engagements from the current season. Availability is confirmed privately upon enquiry."
          />
          <div className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {EVENTS.map((e, i) => (
              <EditorialCard key={e.title} {...e} static delay={(i % 3) * 0.1} onCta={() => openEnquiry("Events")} ctaLabel="Enquire" />
            ))}
          </div>
        </section>
      </PageShell>
    </Page>
  );
}
